import { IContribute } from "./contribute.model";

export interface IPaymentConfig {
  currency?: string;
  enable_sip_switch?: boolean;
  is_sip?: boolean;
  mini_story?: boolean;
  origin?: string;
  sip_contribute_details?: IContribute;
}

export const PAYMENT_DEFAULT_CONFIG: IPaymentConfig = {
  enable_sip_switch: false,
  is_sip: false
}